import { FieldRenderProps } from 'react-final-form'
import Dropdown from '../../control/Dropdown'

type ProvinceInputProps = FieldRenderProps<any, HTMLElement>

const ProvinceInput: React.FC<ProvinceInputProps> = ({ input, meta, options, ...rest }) => {
    return <Dropdown {...input} {...rest} meta={meta} options={options} helperText={meta.error} />
}

export default ProvinceInput
